import WebSocketStore from 'core/classes/services/WebSocketStore'

import { AplDocumentTypes, IAplDocument } from '../models/aplDocument'

export interface IFetchAplDocumentWithParameters {
  languageCode: string
  type: AplDocumentTypes
}

export const fetchAplDocumentByParameters = async ({
  languageCode,
  type,
}: IFetchAplDocumentWithParameters) => {
  try {
    const wsClient = WebSocketStore.get('onboarding')
    const result = await wsClient.call<IAplDocument>({
      service: 'apl',
      action: 'get-apl-document-by-parameters',
      payload: {
        languageCode,
        type,
      },
    })

    return result.data
  } catch (e) {
    return null
  }
}
